import type { Prototype } from "../prototype-types";

export const wyattHaymanPrototypes: Prototype[] = [
  {
    id: "wh-maze-test",
    name: "Maze Test",
    path: "/wh/maze-test",
    description:
      "Shipping-details flow with hash-based URL steps for Maze path testing (same UI as brand-order packing-slip).",
    owner: "Wyatt Hayman",
    createdAt: "2026-05-15",
    lastUpdated: "2026-05-15",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    thumbnail: "https://cdn.prerelease.faire.dev/fastly/be1f291a8f3bab7c90e81f2ba6a3542d0cbd3249be6c9f4edf78ef3e3215e1c3.png",
    creationTool: "cursor",
  },
  {
    id: "wh-brand-order-packing-slip",
    name: "Brand order — packing slip & shipping",
    path: "/wh/brand-order-packing-slip",
    description:
      "Exploration of brand order detail: packing slip, print flows, and shipping details with URL-based interaction tracking.",
    owner: "Wyatt Hayman",
    createdAt: "2026-05-13",
    lastUpdated: "2026-05-13",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    thumbnail: "https://cdn.prerelease.faire.dev/fastly/be1f291a8f3bab7c90e81f2ba6a3542d0cbd3249be6c9f4edf78ef3e3215e1c3.png",
    creationTool: "cursor",
  },
];
